import { insertTrackEvent } from './common.js';

const trackWebPushPromptShown = label => {
	insertTrackEvent({
		category: 'WebPush',
		action: 'shown',
		label
	});
};

const trackWebPushPromptPermissionDenied = label => {
	insertTrackEvent({
		category: 'WebPush',
		action: 'denied',
		label
	});
};

const trackWebPushPromptPermissionAccepted = label => {
	insertTrackEvent({
		category: 'WebPush',
		action: 'accepted',
		label
	});
};

const trackWebPushUserEvents = (action, username = '') => {
	insertTrackEvent({
		category: 'WebPush',
		action,
		label: username
	});
};

export {
	trackWebPushPromptShown,
	trackWebPushPromptPermissionDenied,
	trackWebPushPromptPermissionAccepted,
	trackWebPushUserEvents
};
